import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const DeleteProfileImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProfileImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOrganizationLogo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logoHash"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"DeleteProfileImage","document":DeleteProfileImageDocument}} as const;
export type DeleteProfileImageMutationVariables = Types.Exact<{
  orgId: Types.Scalars['ID']['input'];
}>;


export type DeleteProfileImageMutation = (
  { __typename: 'Mutation' }
  & { deleteOrganizationLogo?: Types.Maybe<(
    { __typename: 'Organization' }
    & Pick<Types.Organization, 'id' | 'logoHash'>
  )> }
);

export type DeleteProfileImageMutationFn = Apollo.MutationFunction<
  DeleteProfileImageMutation,
  DeleteProfileImageMutationVariables
>;

/**
 * __useDeleteProfileImageMutation__
 *
 * To run a mutation, you first call `useDeleteProfileImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProfileImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProfileImageMutation, { data, loading, error }] = useDeleteProfileImageMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useDeleteProfileImageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteProfileImageMutation,
    DeleteProfileImageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteProfileImageMutation,
    DeleteProfileImageMutationVariables
  >(DeleteProfileImageDocument, options);
}
export type DeleteProfileImageMutationHookResult = ReturnType<
  typeof useDeleteProfileImageMutation
>;
export type DeleteProfileImageMutationResult =
  Apollo.MutationResult<DeleteProfileImageMutation>;
export type DeleteProfileImageMutationOptions = Apollo.BaseMutationOptions<
  DeleteProfileImageMutation,
  DeleteProfileImageMutationVariables
>;
